import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaMobileAlt,
  FaRocket,
  FaChartLine,
  FaGlobeAmericas,
} from "react-icons/fa";
import TechStackCard from "./TechStackCard";
import Aboutcard from "./AboutCard";
import SocialMedia from "../SocialMedia";
import developer from "../../Assets/developer.jpg";
import { TECH_STACK, ABOUT_HIGHLIGHTS, ABOUT_SERVICES } from "../../Constants";

const HIGHLIGHT_ICONS = {
  mobile: FaMobileAlt,
  rocket: FaRocket,
  chart: FaChartLine,
  globe: FaGlobeAmericas,
};

function About() {
  return (
    <Container fluid className="about-section" id="about">
      <Container>
        <Row className="about-hero-row">
          <Col lg={7} md={12} className="about-hero-content">
            <span className="about-eyebrow">Work with me</span>
            <h1 className="about-main-heading">
              Your Partner in Building Products That{" "}
              <strong className="purple">Grow</strong>
            </h1>
            <p className="about-subheading">
              I help startups and small businesses launch products that attract
              users and drive revenue—from websites and APIs to mobile apps.
            </p>
            <Aboutcard />
            <div className="about-ctas">
              <a
                href="mailto:azkabashir402@gmail.com?subject=Free%2015-min%20audit"
                className="btn btn-primary"
              >
                Book free 15‑min audit
              </a>
              <Link to="/project" className="btn btn-outline-primary about-cta-secondary">
                See my work
              </Link>
            </div>
          </Col>

          <Col lg={5} md={12} className="about-img-col">
            <div className="about-img-frame">
              <img src={developer} alt="Azka Bashir - Full Stack Developer" className="about-profile-img" />
            </div>
          </Col>
        </Row>

        <Row className="about-highlights-row">
          {ABOUT_HIGHLIGHTS.map((item, index) => {
            const Icon = HIGHLIGHT_ICONS[item.icon];
            return (
              <Col key={index} xs={6} md={3} className="about-highlight-col">
                <div className="about-highlight-card">
                  <div className="about-highlight-icon">
                    <Icon />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.detail}</p>
                </div>
              </Col>
            );
          })}
        </Row>

        <Row className="about-services-row">
          <Col xs={12}>
            <h2 className="about-section-heading">
              How I <strong className="purple">Help Clients</strong>
            </h2>
          </Col>
          {ABOUT_SERVICES.map((service, index) => (
            <Col key={index} lg={3} md={6} xs={12} className="about-service-col">
              <div className="about-service-card">
                <span className="about-service-number">0{index + 1}</span>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="tech-stack-row">
          <Col xs={12}>
            <h2 className="about-section-heading">
              Technologies I <strong className="purple">Deliver With</strong>
            </h2>
            <p className="about-tech-intro">
              Every project is different. Here is the stack I use—React, Next.js,
              Vue.js, React Native, Node.js, and Express—depending on what your
              product actually needs.
            </p>
          </Col>
          {TECH_STACK.map((stack, index) => (
            <Col key={index} lg={3} md={6} xs={12} className="tech-stack-col">
              <TechStackCard
                category={stack.category}
                clientValue={stack.clientValue}
                technologies={stack.technologies}
              />
            </Col>
          ))}
        </Row>

        <Row className="about-contact-row">
          <Col xs={12} className="about-contact-card">
            <h2>Ready to grow your product?</h2>
            <p>
              Have an idea or an app that needs improvement? Let&apos;s talk—I&apos;ll
              share practical steps you can apply right away.
            </p>
            <SocialMedia />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
